export const whatsAppMessages = {
  changeOptions:
    'Olá, quero fazer um agendamento de consultas com novas opções de data, local ou turnos.',
  default:
    'Olá, Dora. Estava no site e quero continuar a agendar minha consulta.',
  initial: 'Estava no site e quero agendar uma consulta',
  doraMessage:
    'Olá, estou de volta e quero agendar minha consulta pelo whatsapp.',
  sulamericaIndividualPE:
    'Olá Dora, tentei agendar pelo site e quero continuar agendar uma consulta por aqui no WhatsApp.'
}
